"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nestPasNulOuVide = nestPasNulOuVide;
exports.estDefini = estDefini;
exports.valeursUniques = valeursUniques;
exports.filtrerProprietesObjet = filtrerProprietesObjet;
exports.extraireProprietesObjet = extraireProprietesObjet;
exports.trimmerSiNonNul = trimmerSiNonNul;
exports.guid = guid;
exports.decouper = decouper;
exports.extraireChaineRequete = extraireChaineRequete;
exports.construireChemin = construireChemin;
exports.elementEstEgalA = elementEstEgalA;
exports.elementEstVisible = elementEstVisible;
exports.mettreAuPluriel = mettreAuPluriel;
exports.essaieObtenirRegexp = essaieObtenirRegexp;
exports.cloner = cloner;
exports.objetsEgaux = objetsEgaux;
exports.enregistrerSiDefini = enregistrerSiDefini;
exports.estNombre = estNombre;
exports.objetVide = objetVide;
exports.appelSecurise = appelSecurise;
exports.siNonDefini = siNonDefini;
exports.siDefini = siDefini;
exports.enleverAccent = enleverAccent;
exports.boucleAsyncrone = boucleAsyncrone;
exports.extraireNumeroTelephoneFormate = extraireNumeroTelephoneFormate;
exports.obtenirValeurs = obtenirValeurs;

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

String.prototype.remplacer = function () {
  var entrees = decouper(arguments);
  entrees = combinerArguments.apply(null, entrees);
  var chaine = this;

  for (var index = 0; index < entrees.length; index++) {
    chaine = chaine.replace(new RegExp("\\{".concat(index, "\\}"), 'g'), entrees[index]);
  }

  return chaine;
};

Array.prototype.prendrePlusieurs = function (fcnPlusieurs) {
  return this.reduce(function (rangee, objet) {
    var objets = fcnPlusieurs(objet);

    if (estDefini(objets) && objets instanceof Array) {
      rangee.push.apply(rangee, objets);
    }

    return rangee;
  }, []);
};

Array.prototype.contientUn = function () {
  var _this = this;

  var args = decouper(arguments);
  var valeurs = combinerArguments.apply(null, args);
  return valeurs.some(function (val) {
    return _this.indexOf(val) !== -1;
  });
};

Number.prototype.arrondir = function (nombreDeDecimal) {
  var facteur = Math.pow(10, nombreDeDecimal);
  return Math.round(this * facteur) / facteur;
};

function nestPasNulOuVide(valeur) {
  return estDefini(valeur) && valeur.toString().trim() !== '';
}

function estDefini(valeur) {
  var valeurEstDefinie = valeur !== undefined && valeur !== null;

  if (!valeurEstDefinie) {
    return false;
  }

  var args = decouper(arguments);

  if (args.length == 1) {
    return true;
  }

  return estDefiniRecursif.apply(null, args);
}

function estDefiniRecursif() {
  var args = decouper(arguments);
  var valeur = args.shift();
  return args.every(function (argument) {
    if (argument instanceof Array) {
      var cle = argument.shift();
      var valeurCle = valeur[cle];

      if (!estDefini(valeurCle)) {
        return false;
      }

      argument.unshift(valeurCle);
      return estDefiniRecursif.apply(null, argument);
    } else {
      return estDefini(valeur[argument]);
    }
  });
}

function valeursUniques(valeurs) {
  var valeursUniques = [];

  if (!valeurs || !valeurs.length || !valeurs.forEach) {
    return valeursUniques;
  }

  valeurs.forEach(function (valeur) {
    if (valeursUniques.indexOf(valeur) === -1) {
      valeursUniques.push(valeur);
    }
  });
  return valeursUniques;
}

function filtrerProprietesObjet(objet) {
  var args = decouper(arguments);
  args.shift();
  var proprietes = combinerArguments.apply(null, args);
  var nouvelObj = {};
  Object.keys(objet).filter(function (cle) {
    return proprietes.indexOf(cle) === -1;
  }).forEach(function (cle) {
    return nouvelObj[cle] = objet[cle];
  });
  return nouvelObj;
}

function extraireProprietesObjet(objet) {
  var args = decouper(arguments);
  args.shift();
  var proprietes = combinerArguments.apply(null, args);
  var nouvelObj = {};
  Object.keys(objet).filter(function (cle) {
    return proprietes.indexOf(cle) !== -1;
  }).forEach(function (cle) {
    return nouvelObj[cle] = objet[cle];
  });
  return nouvelObj;
}

function combinerArguments() {
  var args = decouper(arguments);
  return args.reduce(function (rangee, valeur) {
    if (valeur instanceof Array) {
      rangee.push.apply(rangee, valeur);
    } else {
      rangee.push(valeur);
    }

    return rangee;
  }, []);
}

function trimmerSiNonNul(chaine) {
  return chaine && chaine.trim ? chaine.trim() : chaine;
}

function guid() {
  return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[x]/g, function (c) {
    var r = Math.random() * 16 | 0;
    return r.toString(16);
  });
}

function decouper(objet) {
  var fonctionDecoupage = Array.prototype.slice;
  return fonctionDecoupage.apply(objet);
}

function extraireChaineRequete(proprietes) {
  proprietes = typeof proprietes === 'string' ? [proprietes] : proprietes;

  var chaineRequete = _queryString.default.parse(window.location.search);

  var nouvelleChaine = {};
  proprietes.forEach(function (propriete) {
    var valeur = chaineRequete[propriete];

    if (nestPasNulOuVide(valeur)) {
      nouvelleChaine[propriete] = valeur;
    }
  });
  var chaineVide = !Object.keys(nouvelleChaine).length;
  return !chaineVide ? "?".concat(_queryString.default.stringify(nouvelleChaine)) : null;
}

function construireChemin(nomChemin, proprietesChaineRequete) {
  var toutesLesProprietes = ['contexteSAI'].concat(proprietesChaineRequete || []);
  var chaineRequete = extraireChaineRequete(toutesLesProprietes);
  return {
    pathname: nomChemin,
    search: chaineRequete
  };
}

function elementEstEgalA(element, valeur) {
  return estDefini(element) && element === valeur;
}

function elementEstVisible(visibilite) {
  var estVisible = elementEstEgalA(visibilite, true);

  if (!estVisible) {
    estVisible = !elementEstEgalA(visibilite, false);
  }

  return estVisible;
}

function mettreAuPluriel(nombre, mot, concatenerMots, motAuPluriel) {
  try {
    var motPluriel = typeof motAuPluriel !== 'undefined' ? motAuPluriel : '';
    var concatener = typeof concatenerMots !== 'undefined' ? concatenerMots : false;

    if (isNaN(nombre) === false && nombre > 1) {
      if (concatener) {
        if (motPluriel !== '') {
          return nombre + ' ' + motAuPluriel;
        } else {
          return nombre + ' ' + mot + 's';
        }
      } else {
        if (motPluriel !== '') {
          return motAuPluriel;
        } else {
          return mot + 's';
        }
      }
    } else if (isNaN(nombre) === false && concatener === true && (nombre === 1 || nombre === 0)) {
      return nombre + ' ' + mot;
    }
  } catch (err) {}

  return mot;
}

function essaieObtenirRegexp(expressionChaine) {
  if (!estDefini(expressionChaine)) {
    return null;
  }

  try {
    return new RegExp(expressionChaine);
  } catch (ex) {
    return null;
  }
}

function cloner(objet) {
  return clonerInterne(objet, []);
}

function clonerInterne(objet, references) {
  if (!estDefini(objet) || typeof objet === 'string' || Object.keys(objet).length === 0) {
    return objet;
  }

  return objet instanceof Array ? objet.map(function (obj) {
    return clonerInterne(obj, references);
  }) : Object.keys(objet).reduce(function (obj, cle) {
    var valeur = objet[cle];
    obj[cle] = valeur instanceof Array ? valeur.map(function (val) {
      return obtenirClone(val, references);
    }) : obtenirClone(valeur, references);
    return obj;
  }, {});
}

function obtenirClone(objet, references) {
  if (!estDefini(objet)) {
    return objet;
  } else if (Object.keys(objet).length === 0) {
    return objet;
  } else if (references.some(function (obj) {
    return obj === objet;
  })) {
    return objet;
  }

  references.push(objet);
  return clonerInterne(objet, references);
}

function objetsEgaux(a, b) {
  var bNonDefini = !estDefini(b);

  if (!estDefini(a)) {
    return bNonDefini;
  } else if (bNonDefini) {
    return false;
  }

  if (_typeof(a) !== 'object' || _typeof(b) !== 'object') {
    return false;
  }

  var cleA = Object.keys(a);
  var cleB = Object.keys(b);

  if (cleA.length !== cleB.length || cleA.some(function (cle) {
    return cleB.indexOf(cle) === -1;
  })) {
    return false;
  }

  return cleA.every(function (cle) {
    var valA = a[cle];
    var valB = b[cle];

    if (_typeof(valA) !== _typeof(valB)) {
      return false;
    } else if (_typeof(valA) === 'object') {
      return objetsEgaux(valA, valB);
    }

    return valA === valB;
  });
}

function enregistrerSiDefini(objet, nom, valeur) {
  if (estDefini(valeur)) {
    objet[nom] = valeur;
  }
}

function estNombre(valeur) {
  return estDefini(valeur) && !isNaN(Number(valeur));
}

function objetVide(objet) {
  return _typeof(objet) === 'object' && Object.keys(objet).length === 0;
}

function appelSecurise(appel, contexte) {
  if (!estDefini(contexte, 'blocsApplicatifs')) {
    return;
  }

  var args = decouper(arguments);
  args.shift();
  args.shift();
  var blocsApplicatifs = combinerArguments.apply(null, args);

  if (args.length == 0 || contexte.blocsApplicatifs.contientUn(blocsApplicatifs)) {
    appel();
  }
}

function siNonDefini() {
  var args = decouper(arguments);
  var objetSiNonDefini = args.pop();
  return estDefini.apply(null, args) ? args.shift() : objetSiNonDefini;
}

function siDefini() {
  var args = decouper(arguments);
  var fonctionSiDefini = args.pop();
  return estDefini.apply(null, args) ? fonctionSiDefini(args.shift()) : null;
}

function enleverAccent(chaine) {
  if (!nestPasNulOuVide(chaine)) {
    return chaine;
  }

  return chaine.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

function boucleAsyncrone(callbackIteration, callbackFin) {
  var frequence = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  var callbackApres = arguments.length > 3 ? arguments[3] : undefined;
  var interval = setInterval(function () {
    if (callbackFin()) {
      clearInterval(interval);

      if (estDefini(callbackApres)) {
        callbackApres();
      }
    } else {
      callbackIteration();
    }
  }, frequence);
}

function extraireNumeroTelephoneFormate(no) {
  if (!estDefini(no)) {
    return null;
  }

  var exp = /^(\d\d\d)[- ]?(\d\d\d)[- ]?(\d\d\d\d)$/;
  var match = no.toString().match(exp);

  if (!estDefini(match)) {
    return null;
  }

  return "".concat(match[1], " ").concat([2, 3].map(function (n) {
    return match[n];
  }).join('-'));
}

function obtenirValeurs(objet) {
  var cles;

  if (!estDefini(objet) || typeof object === 'string' || (cles = Object.keys(objet)).length === 0) {
    return objet;
  }

  return cles.map(function (cle) {
    return objet[cle];
  });
}